import { z } from 'zod';
import { Option } from '../../types/Option';

export type ConductorFlexibility =
    | 'solid'
    | 'stranded'
    | 'class1'
    | 'class2'
    | 'class3'
    | 'class4'
    | 'class5'
    | 'class6';

const options = [
    { value: 'solid', label: 'Solid' },
    { value: 'stranded', label: 'Stranded' },
    { value: 'class1', label: 'Class 1' },
    { value: 'class2', label: 'Class 2' },
    { value: 'class3', label: 'Class 3' },
    { value: 'class4', label: 'Class 4' },
    { value: 'class5', label: 'Class 5' },
    { value: 'class6', label: 'Class 6' },
] as Option<ConductorFlexibility>[];

const validator = z.enum(['solid', 'stranded', 'class1', 'class2', 'class3', 'class4', 'class5', 'class6']);

export const ConductorFlexibility = {
    validator,
    options,
};
